import React from "react";
import { House } from "lucide-react";
import { useTranslation } from "react-i18next";
import ROUTES from "../../services/AppConstant";
import { Button } from "../../components/ui/button";
import { S_TEXT, TEXT } from "../../constant/textConstants";

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[calc(100vh-200px)] items-center justify-center p-4">
      <div className="flex w-full max-w-2xl flex-col items-center space-y-8 text-center">
        {/* Main 404 heading */}
        <div className="relative">
          <h1 className="animate-pulse text-[120px] font-bold text-purple-1 md:text-[180px]">
            {S_TEXT?.[404]}
          </h1>
          <div className="absolute inset-0 bottom-0 h-1/2 bg-gradient-to-t from-background to-transparent" />
        </div>

        {/* Text Section */}
        <div className="space-y-3">
          <h2 className="text-3xl font-semibold md:text-4xl">
            {t(TEXT.PAGE_NOT_FOUND)}
          </h2>
          <p className="text-blue-gray mx-auto max-w-lg text-base md:text-lg">
            {t(TEXT.PAGE_NOT_FOUND_DESCRIPTION)}
          </p>
        </div>

        {/* Button Section */}
        <div className="flex flex-col items-center justify-center md:flex-row">
          <Button
            variant="secondary"
            aria-label="Go Back"
            className="gap-1 font-semibold"
            onClick={() => (window.location.href = ROUTES?.HOME)}
          >
            <House className="!h-4 !w-4" />
            {t(TEXT.GO_BACK)}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
